module.exports = __webpack_public_path__ + "static/media/fechar-menu-icon.a6c6ca6a.svg";